// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_b5-0";